import { useEffect, useState } from "react";
import {
  openNativeAppStore,
  shouldShowNativeUpdateBanner,
  snoozeNativeUpdateBanner,
} from "../utils/nativeAppUpdate";

/**
 * Dismissible "new app version" banner for ZyMedElite users on outdated native builds.
 * Those builds predate the native update prompt, so the PWA is the only way to reach them.
 */
const NativeUpdateBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Native injects NATIVE_APP_VERSION before content loads, but re-check after mount
    // in case the injection landed late.
    setVisible(shouldShowNativeUpdateBanner());
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    snoozeNativeUpdateBanner();
    setVisible(false);
  };

  return (
    <div
      className="fixed left-0 right-0 z-50 px-4"
      style={{ top: "calc(var(--safe-area-inset-top, 0px) + 12px)" }}
    >
      <div className="mx-auto max-w-md rounded-xl bg-white p-4 shadow-lg border border-gray-200">
        <p className="text-sm font-semibold text-gray-900">New app version available</p>
        <p className="mt-1 text-xs text-gray-600">
          Update ZyMedElite for the latest features and fixes.
        </p>
        <div className="mt-3 flex justify-end gap-2">
          <button
            type="button"
            className="rounded-lg px-3 py-1.5 text-sm text-gray-600"
            onClick={dismiss}
          >
            Later
          </button>
          <button
            type="button"
            className="rounded-lg bg-[#4B4AD5] px-4 py-1.5 text-sm font-medium text-white"
            onClick={openNativeAppStore}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default NativeUpdateBanner;
